import React, { ReactNode } from 'react'
import { CalendarListItem } from './CalendarListItem'
import { SpinnerWrapper } from '../../common/SpinnerWrapper'
import { ErrorView } from '../../../views/error/ErrorView'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { IllustrationChoices } from '../../common/Illustration'
import { IEventModel } from '../../../interfaces/models/events.interfaces'
import { IBoardRoomEventModel } from '../../../interfaces/models/boardroom-events.interfaces'

interface CalendarListProps {
  events: IEventModel[] | IBoardRoomEventModel[]
  loading?: boolean
  userIsAdmin?: boolean
  boardRoomEvent?: boolean
}

export const CalendarList = ({
  events,
  loading,
  userIsAdmin,
  boardRoomEvent,
}: CalendarListProps): ReactNode => {
  const { translate } = useAppTranslation()
  if (loading) {
    return <SpinnerWrapper />
  }

  if (!loading && events.length === 0) {
    return (
      <ErrorView
        title={translate('societyCalendarListView.noCalendarEvents.title')}
        subtitle={translate(
          'societyCalendarListView.noCalendarEvents.subtitle'
        )}
        illustration={IllustrationChoices.CHECKLIST}
        className="mt-4 md:mt-8"
      />
    )
  }

  return (
    <div className="w-full space-y-4">
      {events.map((_event) => (
        <CalendarListItem
          key={_event._id}
          event={_event}
          displayEdit={userIsAdmin}
          boardRoomEvent={boardRoomEvent}
        />
      ))}
    </div>
  )
}
